(function() {
    'use strict';
    const allowedDomains = [
        "https://shopessteem.com",
        "https://shopessteem.myshopify.com",
        "https://editor.gempages.net"
    ];
    const elements = {
        pickerDisplay: null,
        freePopup: null,
        paidPopup: null,
        popupCloseButtons: null,
        productCollections: null,
        addToCartButton: null,
        requiredProducts: null,
        cartContainer: null,
        checkoutButton: null
    };
    const state = {
        productCache: new Map(),
        selectedTarget: null,
        selectedProducts: [],
        selectedRequiredProducts: new Map(),
        selectedOptionalProducts: new Map(),
        cartBundles: JSON.parse(localStorage.getItem('cartBundles') || '[]'),
        localCartState: { items: [], count: 0 },
        lastCartUpdate: 0,
        previousSelections: new Map(),
        currentTarget: null
    };
    function debounce(func, wait) {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), wait);
        };
    }
    function getCurrentProduct() {
        const productForm = document.querySelector('form[action$="/cart/add"]');
        const productIdInput = productForm?.querySelector('[name="id"]');
        return productIdInput ? {
            id: parseInt(productIdInput.value),
            quantity: 1,
            properties: { "main product id": parseInt(productIdInput.value), "isMainProduct": "true" }
        } : null;
    }
    function openPopup(target) {
        state.selectedTarget = target;
        const popup = target.classList.contains("required-product") ? 
            elements.freePopup : elements.paidPopup;
        popup.classList.add("open");
    }
    function openPaidPopup(target) {
        state.currentTarget = target;
        elements.paidPopup.classList.add("open");
    }
    function closePopup() {
        elements.freePopup.classList.remove("open");
        elements.paidPopup.classList.remove("open");
        state.selectedTarget = null;
        state.currentTarget = null;
    }
    function checkRequiredSelections() {
        if (elements.addToCartButton) {
            const hasRequiredSelections = state.selectedRequiredProducts.size === elements.requiredProducts.length;
            const hasMainProduct = !!getCurrentProduct();
            elements.addToCartButton.classList.toggle('disabled', !(hasRequiredSelections && hasMainProduct));
        }
    }
    function isCartValidForCheckout(cart) {
        const mainProductIds = new Set(cart.items
            .filter(item => item.properties?.isMainProduct === "true")
            .map(item => item.variant_id));

        return !cart.items.some(item => 
            item.properties?.["Product Id"] && 
            !item.properties["isMainProduct"] && 
            !item.properties["isOptional"] && 
            !mainProductIds.has(parseInt(item.properties["Product Id"]))
        );
    }
    const updateCheckoutButtonState = debounce(async () => {
        try {
            const response = await fetch('/cart.js');
            const cart = await response.json();
            if (elements.checkoutButton) {
                elements.checkoutButton.disabled = !isCartValidForCheckout(cart);
                if (!isCartValidForCheckout(cart)) {
                    await updateCartOnMainProductRemoval(); // Clean up invalid cart
                }
            }
        } catch (error) {
            console.error("Failed to fetch cart:", error);
        }
    }, 100);
    const updateCartDrawer = debounce(async (cart) => {
        try {
            const cartUrl = window.routes?.cart_url || '/cart';
            const response = await fetch(`${cartUrl}?section_id=cart-drawer`);
            const responseText = await response.text();
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            
            ['cart-drawer-items', '.cart-drawer__footer', '.cart-items', '.mini-cart-items']
                .forEach(selector => {
                    const target = document.querySelector(selector);
                    const source = html.querySelector(selector);
                    if (target && source) target.replaceWith(source);
                });
        } catch (error) {
            console.error("Failed to update cart drawer:", error);
        }
    }, 100);
    async function refreshCartDrawer(cartData) {
        try {
            const cartDrawer = document.querySelector('cart-drawer.drawer');
            if (!cartDrawer) {
                console.warn('Cart drawer component not found');
                return;
            }
            if (cartData?.sections?.['cart-drawer']) {
                if (cartDrawer.renderContents) {
                    try {
                        if (typeof cartData.sections['cart-drawer'] === 'string' && cartData.sections['cart-drawer'].trim()) {
                            cartDrawer.renderContents({ sections: { 'cart-drawer': cartData.sections['cart-drawer'] } });
                        } else {
                            throw new Error('Invalid cart-drawer section data');
                        }
                    } catch (renderError) {
                        await fetchFreshCartSection(cartDrawer);
                    }
                } else {
                    await fetchFreshCartSection(cartDrawer);
                }
            } else {
                await fetchFreshCartSection(cartDrawer);
            }
            const latestCartData = await fetchLatestCartData();
            updateCartEmptyState(cartDrawer, latestCartData?.item_count || 0);
            updateCartCountBubble(latestCartData?.item_count || 0);
        } catch (error) {
            console.error('Cart drawer refresh failed:', error);
            await updateCartDrawer(cartData); 
        }
    }
    async function fetchFreshCartSection(cartDrawer) {
        try {
            const response = await fetch('/?section_id=cart-drawer');
            if (!response.ok) throw new Error('Failed to fetch cart-drawer section');
            const html = await response.text();
            if (cartDrawer && cartDrawer.renderContents && html) {
                cartDrawer.renderContents({ sections: { 'cart-drawer': html } });
            }
        } catch (fetchError) {
            // console.error('Failed to fetch fresh cart section:', fetchError);
        }
    }
    async function fetchLatestCartData() {
        try {
            const response = await fetch('/cart.js');
            if (!response.ok) throw new Error('Failed to fetch cart data');
            return await response.json();
        } catch (error) {
            console.error('Error fetching latest cart data:', error);
            return { item_count: 0 };
        }
    }

    function updateCartEmptyState(cartDrawer, itemCount) {
        const drawerInnerEmpty = cartDrawer.querySelector('.drawer__inner-empty');
        const overlay = document.querySelector('.cart-drawer__overlay');
        if (overlay) {
            overlay.addEventListener('click', function handler() {
                document.body.classList.remove('overflow-hidden');
                cartDrawer.classList.remove('active');
                overlay.removeEventListener('click', handler);
            }, { once: true });
        }
        if (itemCount === 0) {
            cartDrawer.classList.add('is-empty');
            if (drawerInnerEmpty) drawerInnerEmpty.style.display = 'flex';
        } else {
            cartDrawer.classList.remove('is-empty');
            if (drawerInnerEmpty) drawerInnerEmpty.style.display = 'none';
        }
    }
    function updateCartCountBubble(itemCount) {
        const cartCountBubble = document.querySelector('.cart-count-bubble');
        if (cartCountBubble) {
            cartCountBubble.textContent = itemCount;
            cartCountBubble.style.display = itemCount > 0 ? 'inline-flex' : 'none';
        }
    }
    function createOptionalProductElement(productData) {
        const productElement = document.createElement('div');
        productElement.classList.add('custom-product', 'optional-product');
        productElement.dataset.productId = productData.id;
        productElement.innerHTML = `
            <div class="varint-shop-image">
                <img src="${productData.image}" alt="${productData.title}">
            </div>
            <h2>${productData.title}</h2>
            <button class="remove-product" data-product-id="${productData.id}">X</button>
        `;
        return productElement;
    }
    function handleProductSelection(event) {
        const button = event.target.closest(".add-product-button");
        if (!button || !state.selectedTarget) return;
        const productContainer = button.parentElement;
        const variantId = parseInt(productContainer.dataset.productId);
        if (!variantId) return;
        const productImage = button.querySelector("img")?.src || "";
        const productTitle = button.querySelector("p")?.textContent || "Unknown Product";
        const selectedProductHTML = `
            <div class="custom-product" data-product-id="${variantId}">
                <div class="varint-shop-image"><img src="${productImage}" alt="${productTitle}"></div>
                <h2>${productTitle}</h2>
            </div>
        `;
        if (state.selectedTarget.classList.contains("required-product")) {
            const mainProduct = getCurrentProduct();
            if (!mainProduct) return;
            state.previousSelections.set(state.selectedTarget, state.selectedTarget.innerHTML);
            state.selectedRequiredProducts.set(state.selectedTarget, {
                id: variantId,
                quantity: 1,
                properties: { "Product Id": mainProduct.id }
            });
            state.selectedTarget.innerHTML = selectedProductHTML;
        } else {
            const existingProducts = elements.pickerDisplay?.parentElement.querySelectorAll('.custom-product:not(.optional-product)');
            existingProducts?.forEach(product => product.style.display = 'none');
            
            state.selectedProducts.push({ id: variantId, quantity: 1, target: state.selectedTarget });
            state.productCache.set(variantId, state.selectedProducts.length - 1);
            elements.pickerDisplay?.insertAdjacentHTML('beforebegin', selectedProductHTML);
        }
        checkRequiredSelections();
        closePopup();
    }
    function handleOptionalProductSelection(event) {
        const button = event.target.closest(".add-product-button");
        if (!button || !state.currentTarget) return;
        const productContainer = button.parentElement;
        const variantId = parseInt(productContainer.dataset.productId);
        if (!variantId) return;
        const productImage = button.querySelector("img")?.src || "";
        const productTitle = button.querySelector("p")?.textContent || "Unknown Product";
        const productData = {
            id: variantId,
            title: productTitle,
            image: productImage,
            quantity: 1,
            removable: true
        };
        state.selectedOptionalProducts.set(variantId, productData);
        const productElement = createOptionalProductElement(productData);
        elements.pickerDisplay.parentElement.insertBefore(productElement, elements.pickerDisplay);
        productElement.querySelector('.remove-product').addEventListener('click', (e) => {
            e.preventDefault();
            removeOptionalProduct(variantId, productElement);
        });
        closePopup();
    }
    function removeOptionalProduct(variantId, productElement) {
        state.selectedOptionalProducts.delete(variantId);
        productElement.remove();
    }
    function restorePreviousSelections() {
        state.selectedProducts = [];
        state.selectedTarget = null;
        state.selectedRequiredProducts.clear();
        state.previousSelections.forEach((html, target) => {
            target.innerHTML = html;
        });
        if (elements.pickerDisplay) {
            const customProducts = elements.pickerDisplay.parentElement.querySelectorAll('.custom-product:not(.optional-product)');
            customProducts.forEach(product => {
                product.style.display = 'block';
            });
        }
        checkRequiredSelections();
    }
    async function handleAddToCart(event) {
        event.preventDefault();
        if (elements.addToCartButton.classList.contains('disabled')) return;
        elements.addToCartButton.querySelector('span').textContent = 'Adding...';
        elements.addToCartButton.classList.add('loading');

        const mainProduct = getCurrentProduct();
        if (!mainProduct) {
            resetButtonState();
            return;
        }
        if (state.selectedRequiredProducts.size !== elements.requiredProducts.length) {
            resetButtonState();
            return;
        }
        const optionalProducts = Array.from(state.selectedOptionalProducts.values()).map(product => ({
            id: product.id,
            quantity: product.quantity,
            properties: {
                "main product id": mainProduct.id,
                "isMainProduct": "false",
                "isOptional": "true"
            }
        }));
        const bundleKey = `${mainProduct.id}-${Array.from(state.selectedRequiredProducts.values())
            .map(p => p.id).sort().join('-')}-${state.selectedProducts
            .map(p => p.id).sort().join('-')}-${optionalProducts
            .map(p => p.id).sort().join('-')}`;
        if (state.cartBundles.some(b => {
            const existingKey = `${b.mainProductId}-${b.requiredProductIds.sort().join('-')}-${b.optionalProductIds.sort().join('-')}`;
            return existingKey === bundleKey;
        })) {
            alert("This bundle is already in your cart!");
            resetButtonState();
            return;
        }
        const bundle = {
            mainProductId: mainProduct.id,
            requiredProductIds: Array.from(state.selectedRequiredProducts.values()).map(p => p.id),
            optionalProductIds: [...state.selectedProducts.map(p => p.id), ...optionalProducts.map(p => p.id)]
        };
        state.cartBundles.push(bundle);
        localStorage.setItem('cartBundles', JSON.stringify(state.cartBundles));
        const itemsToAdd = [
            { ...mainProduct },
            ...Array.from(state.selectedRequiredProducts.values()),
            ...state.selectedProducts.map(p => ({
                id: p.id,
                quantity: p.quantity || 1,
                properties: { "main product id": mainProduct.id, "isMainProduct": "false" }
            })),
            ...optionalProducts
        ];
        try {
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ 
                    items: itemsToAdd,
                    sections: ['cart-drawer', 'cart-items']
                })
            });
            if (!response.ok) throw new Error('Failed to add items to cart');
            const cart = await response.json();
            state.selectedOptionalProducts.clear();
            elements.pickerDisplay.parentElement
                .querySelectorAll('.optional-product')
                .forEach(el => el.remove());
            await refreshCartDrawer(cart);
            await updateCheckoutButtonState();
            const cartDrawer = document.querySelector('cart-drawer.drawer');
            cartDrawer.classList.add('active');
            elements.addToCartButton.querySelector('span').textContent = 'TOEGEVOEGD';
            elements.addToCartButton.classList.remove('loading');
            elements.addToCartButton.classList.add('Thank You');
            setTimeout(() => {
                resetButtonState();
            }, 2000);
        } catch (error) {
            console.error("Failed to add to cart:", error);
            resetButtonState();
        }
    }
    function resetButtonState() {
        elements.addToCartButton.querySelector('span').textContent = 'VOEG TOE AAN WINKELWAGEN';
        elements.addToCartButton.classList.remove('loading', 'Thank You');
        checkRequiredSelections();
    }
    const updateCartOnMainProductRemoval = debounce(async () => {
        const now = Date.now();
        if (now - state.lastCartUpdate < 500) return;
        try {
            state.lastCartUpdate = now;
            const response = await fetch('/cart.js');
            if (!response.ok) throw new Error('Cart fetch failed');
            const cart = await response.json();
            const mainProductIds = new Set(cart.items
                .filter(item => item.properties?.isMainProduct === "true")
                .map(item => item.variant_id));
            const updates = {};
            const bundlesToRemove = [];
            cart.items.forEach(item => {
                const itemMainProductId = parseInt(item.properties?.["Product Id"]) || parseInt(item.properties?.["main product id"]);
                const isOptional = item.properties?.isOptional === "true";
                const isMainProduct = item.properties?.isMainProduct === "true";
                if (!isMainProduct && !isOptional && itemMainProductId && !mainProductIds.has(itemMainProductId)) {
                    updates[item.key] = 0;
                }
            });
            state.cartBundles.forEach((bundle, index) => {
                if (!mainProductIds.has(bundle.mainProductId)) {
                    bundlesToRemove.push(index);
                    cart.items.forEach(item => {
                        const itemMainProductId = parseInt(item.properties?.["Product Id"]) || parseInt(item.properties?.["main product id"]);
                        const isOptional = item.properties?.isOptional === "true";
                        if (!isOptional && (itemMainProductId === bundle.mainProductId || item.variant_id === bundle.mainProductId)) {
                            updates[item.key] = 0;
                        }
                    });
                }
            });
            if (Object.keys(updates).length) {
                const updateResponse = await fetch('/cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ 
                        updates,
                        sections: ['cart-drawer'] 
                    })
                });
                if (!updateResponse.ok) throw new Error('Cart update failed');
                const updatedCart = await updateResponse.json();
                bundlesToRemove.sort((a, b) => b - a)
                    .forEach(index => state.cartBundles.splice(index, 1));
                localStorage.setItem('cartBundles', JSON.stringify(state.cartBundles));
                localStorage.setItem('postReloadAction', JSON.stringify({
                    action: 'refreshCartDrawer',
                    updatedCart: updatedCart
                }));
                window.location.reload();
                return updatedCart;
            }
            await updateCheckoutButtonState();
            return cart;
        } catch (error) {
            console.error("Cart update failed:", error);
            return null;
        }
    }, 200);
    async function handleRemove(event) {
        event.preventDefault();
        const button = event.currentTarget;
        let key = button.dataset.cartItemKey || 
                 button.closest('[data-cart-item]')?.dataset.cartItemKey || 
                 (button.href && new URL(button.href).searchParams.get('id')) || 
                 (button.href && new URL(button.href).searchParams.get('line'));
        if (!key) return;
        const cartItemsWrapper = document.querySelector('.drawer__cart-items-wrapper');
        if (!cartItemsWrapper) {
            console.warn('Cart items wrapper not found');
            return;
        }
        const loaderHTML = `
            <div class="loading-spinner">
                <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                    <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                </svg>
            </div>
        `;
        cartItemsWrapper.insertAdjacentHTML('beforeend', '<div class="cart-loader-overlay">' + loaderHTML + '</div>');
        const loader = cartItemsWrapper.querySelector('.cart-loader-overlay');
        try {
            const response = await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ 
                    id: key, 
                    quantity: 0,
                    sections: ['cart-drawer']
                })
            });
            if (!response.ok) throw new Error('Failed to remove item');
            const cart = await response.json();
            await updateCartOnMainProductRemoval();
            await refreshCartDrawer(cart);
            await updateCheckoutButtonState();
            attachRemoveListeners();
        } catch (error) {
            console.error("Failed to remove item:", error);
        } finally {
            if (loader) loader.remove();
        }
    }
    const attachRemoveListeners = debounce(() => {
        document.querySelectorAll('.cart-remove-button, [data-cart-remove], a[href*="/cart/change"], .cart-item__remove, .remove-from-cart')
            .forEach(button => {
                button.removeEventListener('click', handleRemove);
                button.addEventListener('click', handleRemove, { passive: false });
            });
    }, 200);
    async function handlePostReloadActions() {
        const postReloadAction = localStorage.getItem('postReloadAction');
        if (postReloadAction) {
            try {
                const { action, updatedCart } = JSON.parse(postReloadAction);
                if (action === 'refreshCartDrawer' && updatedCart) {
                    await refreshCartDrawer(updatedCart);
                    await updateCheckoutButtonState();
                }
            } catch (error) {
                console.error('Failed to handle post-reload actions:', error);
            } finally {
                localStorage.removeItem('postReloadAction');
            }
        }
    }
    document.addEventListener('DOMContentLoaded', function() {
        if (!allowedDomains.some(d => typeof d === 'string' ? 
            window.location.origin === d : d.test(window.location.origin))) {
            console.warn("This script is not allowed to run on this site.");
            return;
        }
        elements.pickerDisplay = document.querySelector(".ps-picker__display");
        elements.freePopup = document.querySelector(".free-collection.collection-popup");
        elements.paidPopup = document.querySelector(".paid-collection.collection-popup");
        elements.popupCloseButtons = document.querySelectorAll(".close-button");
        elements.productCollections = document.querySelectorAll(".product-collection");
        elements.addToCartButton = document.querySelector('.custom-add-cart'); 
        elements.requiredProducts = document.querySelectorAll(".required-product");
        elements.cartContainer = document.querySelector('.cart-items, .cart__contents, .order-summary__section--product-list, .cart-drawer, .mini-cart') || document.body;
        elements.checkoutButton = document.querySelector('[name="checkout"], .cart__checkout-button, button[name="goto_pp"], button[name="goto_gc"], .cart-drawer__checkout, .mini-cart__checkout, a[href="/checkout"]');
        elements.requiredProducts.forEach(product => {
            state.previousSelections.set(product, product.innerHTML); 
        });
        elements.popupCloseButtons.forEach(button => 
            button.addEventListener("click", closePopup, { passive: true })
        );
        document.querySelectorAll(".first-product, .secound-product, .required-product")
            .forEach(element => 
                element.addEventListener("click", () => openPopup(element), { passive: true })
            );
        document.querySelectorAll(".ps-picker__display")
            .forEach(element => 
                element.addEventListener("click", () => openPaidPopup(element), { passive: true })
            );
        elements.productCollections.forEach(collection => {
            if (collection.closest('.free-collection')) {
                collection.addEventListener("click", handleProductSelection, { passive: true });
            } else if (collection.closest('.paid-collection')) {
                collection.addEventListener("click", handleOptionalProductSelection, { passive: true });
            }
        });
        [elements.freePopup, elements.paidPopup].forEach(popup => 
            popup.addEventListener("click", (event) => {
                if (event.target === popup) closePopup();
            }, { passive: true })
        );
        if (elements.addToCartButton) {
            elements.addToCartButton.addEventListener("click", handleAddToCart, { passive: false });
            checkRequiredSelections();
        }
        const cartObserver = new MutationObserver(updateCartOnMainProductRemoval);
        cartObserver.observe(elements.cartContainer, { childList: true, subtree: true });
        const bodyObserver = new MutationObserver(attachRemoveListeners);
        bodyObserver.observe(document.body, { childList: true, subtree: true });
        window.addEventListener('unload', () => {
            cartObserver.disconnect();
            bodyObserver.disconnect();
        });
        updateCartOnMainProductRemoval();
        attachRemoveListeners();
        handlePostReloadActions();
    });
    window.updateCartOnMainProductRemoval = updateCartOnMainProductRemoval;
})();